import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=b34303f6&scoped=true&"
import script from "./demo.vue?vue&type=script&lang=js&"
export * from "./demo.vue?vue&type=script&lang=js&"
import style0 from "./demo.vue?vue&type=style&index=0&id=b34303f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34303f6",
  null
  
)

export default component.exports